import { useCallback, useEffect, useState } from "react";
import { coverageRequest } from "services/coverage";
export default function useCoverageAnalysis(file, { requireReceipt = false } = {}) {
  const [attempt, setAttempt] = useState(0);
  const [timing, setTiming] = useState({ startedAt: null, finishedAt: null });
  const [state, setState] = useState({ status: "idle", file: null });
  const retry = useCallback(() => setAttempt((value) => value + 1), []);
  useEffect(() => {
    if (!file) {
      setState({ status: "idle", file: null });
      return undefined;
    }
    let active = true,
      id,
      timer;
    const controller = new AbortController();
    setState({ status: "uploading", file });
    setTiming({ startedAt: performance.now(), finishedAt: null });
    const finish = () => setTiming((current) => ({ ...current, finishedAt: performance.now() }));
    const poll = async () => {
      try {
        const response = await coverageRequest(`/${id}`, { signal: controller.signal });
        const job = await response.json();
        if (!active) return;
        if (job.state === "error") throw new Error(job.message);
        if (job.state === "complete" && requireReceipt && !job.receipt)
          throw new Error(
            "Não foi possível validar a análise para publicação. Tente novamente ou contate a equipe PSO."
          );
        setState({ ...job, id, file, status: job.state });
        if (job.state === "complete") finish();
        else timer = setTimeout(poll, 1500);
      } catch (failure) {
        if (active) {
          finish();
          setState({ status: "error", file, id, message: failure.message });
        }
      }
    };
    (async () => {
      try {
        const response = await coverageRequest("", {
          method: "POST",
          headers: { "Content-Type": "application/pdf" },
          body: file,
        });
        id = (await response.json()).id;
        if (active) await poll();
        else await coverageRequest(`/${id}`, { method: "DELETE" }).catch(() => {});
      } catch (failure) {
        if (active) {
          finish();
          setState({ status: "error", file, message: failure.message });
        }
      }
    })();
    return () => {
      active = false;
      clearTimeout(timer);
      controller.abort();
      if (id) coverageRequest(`/${id}`, { method: "DELETE" }).catch(() => {});
    };
  }, [file, attempt, requireReceipt]);
  return {
    state: state.file === file ? state : { status: file ? "uploading" : "idle", file },
    timing,
    retry,
  };
}
